// extracted by mini-css-extract-plugin
module.exports = {"container":"PopoverPaper_container__3asJl"};